import React, { useEffect, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import jobsData from "../../assets/json/job-role.json";
import "./autocomplete.scss";

const JobAutocomplete = ({setJobTitle, errorJobTitle, onChangeTitle}) => {
   
    const [autocomplete, setAutocomplete] = useState<String[]>();
    const [isError, setIsError] = useState(false);


    useEffect(() => {
        if (errorJobTitle) {
            setIsError(true);
        } else {
            setIsError(false);
        }
    },[errorJobTitle])
    useEffect(() => {

        // Flatten options for Typeahead
        const options = jobsData.flatMap((category) => [
            { id: category.id, name: category.name, nameEn: category.nameEn },
            ...(category.subRole || []),
        ]);
        console.log(options);
        const items = new Array();
        options.map((item) => {
            items.push(item.name + " (" + item.nameEn + ")")
        })
        setAutocomplete(items);
    }, [])

    const handleJobRoleChange = (value) => {
        console.log(value);
        setJobTitle(value[0]);
        onChangeTitle();
    }

    return (
        <>
            {
                autocomplete &&
                <div>
                    <Typeahead
                        onChange={handleJobRoleChange}
                        id="valid-styles-example"
                        inputProps={{
                            className: isError ? 'input-autocomplete-control-error': 'input-autocomplete-control',
                        }}
                        placeholder="ระบุตำแหน่งงาน"
                        options={autocomplete}
                    />
                 
                </div>
            }
        </>

    );
};

export default JobAutocomplete;
